import React, { useState, useEffect } from "react"
import axios from "axios"
import { Modal } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { getCurrentUser } from "../../../helpers/Utils"
import DatePicker from "react-datepicker"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

export default function CledgerModal(props) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [order, setOrder] = useState([])
  const [allData, setAllData] = useState([])
  const [transactionDate, setTransactionDate] = useState(new Date())
  const [paymentType, setPaymentType] = useState("order");
  const getAllOrders = () => {
    setError("")
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/order?customer_id=${
          props.id
        }&type=order,order_service&payment_status=p_paid,unpaid&per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          const orderData = res.data.data.data;

        // Set Orders
        setOrder(orderData);
        
        } else {
          setError(res.data.message)
        }
      })
      .catch(err => {
        console.log("err", err)
      })
  }

  const submitLedger = (e, value) => {
    setLoading(true)
    const api = axios.create()
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    api.interceptors.request.use(config => {
      config.cancelToken = source.token
      return config
    })

    const timeout = 120000 // 2 minute

    setTimeout(() => {
      source.cancel("Timeout")
    }, timeout)
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/ledger`,
        {
          customer_id: props.id,
          order_id: value.order_id,
          amount: value.amount,
          transaction_date: e.target.transaction_date.value,
          message: value.message,
          payment_type: paymentType,
          type: value.type,
        },
        {
          headers: {
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLoading(false)
          props.getAllLedger()
          props.setmodal_standard(false)
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          setLoading(false)
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }
  const leadDisplay = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/order-counts?customer_id=${props.id}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setAllData(res.data.data)
      })
  }
  useEffect(() => {
    getAllOrders()
    leadDisplay()
  }, [])

  useEffect(() => {
    const close = e => {
      if (e.key === "Escape") {
        props.setmodal_standard(false)
      }
    }
    window.addEventListener("keydown", close)
    return () => window.removeEventListener("keydown", close)
  }, [])

  return (
    <>
      <Modal isOpen={props.modal_standard} centered={true}>
        <AvForm
          className="modal-title mt-0"
          id="myModalLabel"
          onValidSubmit={(e, v) => {
            submitLedger(e, v)
          }}
        >
          <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Create Ledger
          </h5>

          <button
            type="button"
            className="cross__btn"
            onClick={() => props.setmodal_standard(false)}
            aria-hidden="true"
          >
            &times;
          </button>
        </div>

        <div className="modal-body">
          {/* Compact Business Summary */}
<div className="d-flex gap-2 mb-3">
  <div
    className="flex-fill border rounded px-3 py-2"
    style={{ background: "#f8f9fa" }}
  >
    <div
      style={{
        fontSize: "12px",
        color: "#6c757d",
        fontWeight: 500,
      }}
    >
      Total Business
    </div>

    <div
      style={{
        fontSize: "18px",
        fontWeight: "700",
        color: "#20b2aa",
      }}
    >
      ₹ {allData.all_orders_with_amount}
    </div>
  </div>

  <div
    className="flex-fill border rounded px-3 py-2"
    style={{ background: "#f8f9fa" }}
  >
    <div
      style={{
        fontSize: "12px",
        color: "#6c757d",
        fontWeight: 500,
      }}
    >
      Balance
    </div>

    <div
      style={{
        fontSize: "18px",
        fontWeight: "700",
        color: "#dc3545",
      }}
    >
      {allData.outstanding}
    </div>
  </div>
</div>

          {/* Payment Type */}
          <div className="mb-4">
            <label className="form-label fw-bold d-block mb-2">
              Payment Type
            </label>

            <div className="d-flex gap-4">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="payment_type"
                  id="orderWise"
                  value="order"
                  checked={paymentType === "order"}
                  onChange={() => setPaymentType("order")}
                />

                <label className="form-check-label" htmlFor="orderWise">
                  Order Wise
                </label>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="payment_type"
                  id="fifoWise"
                  value="fifo"
                  checked={paymentType === "fifo"}
                  onChange={() => setPaymentType("fifo")}
                />

                <label className="form-check-label" htmlFor="fifoWise">
                  FIFO
                </label>
              </div>
            </div>
          </div>

          {/* Show Order Select only for Order Wise */}
          {paymentType === "order" && (
            <div className="mb-3">
              <AvField
                className="select-arrow"
                label="Select Order"
                type="select"
                name="order_id"
                defaultValue={props.ledger && props.ledger.order_id}
              >
                <option value="" hidden>
                  Select
                </option>

                {order &&
                  order.map((item, i) => (
                    <option value={item.id} key={i}>
                      Order id: {item.id}  (balance ₹{item.balance})
                    </option>
                  ))}
              </AvField>

              {error !== "" ? (
                <span className="text-danger">
                  No unpaid or partially paid order found!
                </span>
              ) : (
                ""
              )}
            </div>
          )}

          {/* Amount */}
          <div className="mb-3">
            <AvField
              label="Amount"
              type="number"
              onFocus={e =>
                e.target.addEventListener(
                  "wheel",
                  function (e) {
                    e.preventDefault()
                  },
                  { passive: false }
                )
              }
              min="0"
              max={Number((allData?.outstanding || '0').replace(/₹|,/g, ''))}
              errorMessage="Amount is greater than pending balance"
              name="amount"
              placeholder="Enter Amount"
              defaultValue={props.ledger && props.ledger.amount}
              
            />
          </div>

          {/* Transaction Date */}
          <div className="mb-3">
            <label className="form-group">Transaction Date</label>

            <DatePicker
              className="w-100 form-control"
              dateFormat="yyyy-MM-dd"
              name="transaction_date"
              selected={transactionDate}
              onChange={date => setTransactionDate(date)}
              value={props.ledger && props.ledger.transaction_date}
            />
          </div>

          {/* Message */}
          <div className="mb-3">
            <AvField
              label="Message"
              type="textarea"
              name="message"
              placeholder="Enter message"
              defaultValue={props.ledger && props.ledger.message}
            />
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <div className="text-center">
              {loading ? (
                <button
                  className="btn btn-primary disabled"
                  type="button"
                  disabled
                >
                  Loading
                </button>
              ) : (
                <button
                  className="btn btn-primary"
                  type="submit"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
        </AvForm>
      </Modal>
    </>
  )
}
